
import CityPicker from 'razlet-sdk/lib/components/avia/pricing/city-picker/city-picker';

export default {
  name: 'schedule-filter-cities',
  components: {
    CityPicker,
  },
  model: {
    prop: 'request',
    event: 'change',
  },
  props: {
    request: {
      type: Object,
      default: null,
    },
  },
  computed: {
    showSwap() {
      return (this.request && this.request.from && this.request.to && this.request.from.code && this.request.to.code) || this.$route.name === 'passazhiram-schedule-departure-arrival';
    },
  },
  methods: {
    swapCities(event) {
      this.request.swapCities();
      this.removePress(event);
    },
    addPress(event) {
      event.target.classList.add('btn-swap--pressed');
    },
    removePress(event) {
      event.target.classList.remove('btn-swap--pressed');
    },
  },
};
